import { Image as Image$1 } from '@wix/design-system';
import React__default from 'react';
import { getImageSrc } from 'wix-rich-content-common/libs/imageUtils';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Image = (_a) => {
  var _b = _a, {
    src,
    height,
    width,
    requiredHeight,
    requiredWidth
  } = _b, props = __objRest(_b, [
    "src",
    "height",
    "width",
    "requiredHeight",
    "requiredWidth"
  ]);
  return /* @__PURE__ */ React__default.createElement(
    Image$1,
    __spreadValues({
      fit: "contain",
      style: { minHeight: requiredHeight, height: requiredHeight },
      src: getImageSrc(
        {
          file_name: src,
          id: src,
          width,
          height
        },
        void 0,
        {
          requiredWidth,
          requiredHeight,
          requiredQuality: 80
        }
      ),
      borderRadius: 0
    }, props)
  );
};

export { Image };
//# sourceMappingURL=image.js.map
